import axios from 'axios'
import {ApiConfig as config} from '@/config'

function parseRatings (response) {
  return response.data.ratings
}

export function getManufacturerRatings (manufacturerIds) {
  return new Promise((resolve, reject) => {
    axios.get(`${config.apiUrl}/api/v1/brands-ratings?brandIds=${manufacturerIds.join(',')}`)
      .then(response => resolve(parseRatings(response)))
      .catch(reject)
  })
}



// WEBPACK FOOTER //
// ./src/api/productReviews/getManufacturerRatings.js